module.exports = __webpack_public_path__ + "img/logo.svg?2f671269bd535ecde278fecf8ae9ff21";